import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Sparkles } from 'lucide-react';
import { fadeInUp, fadeInLeft, fadeInRight, smoothTransition, springTransition } from './animations';
import { SolutionImage, SolutionContent } from './SolutionComponents';

export const Solution = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const leftAnimation = useMemo(() => ({
    ...fadeInLeft,
    animate: inView ? fadeInLeft.animate : fadeInLeft.initial,
  }), [inView]);

  const rightAnimation = useMemo(() => ({
    ...fadeInRight,
    animate: inView ? fadeInRight.animate : fadeInRight.initial,
  }), [inView]);

  const headerAnimation = useMemo(() => ({
    ...fadeInUp,
    animate: inView ? fadeInUp.animate : fadeInUp.initial,
  }), [inView]);

  return (
    <section ref={ref} className="py-20 sm:py-28 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      
      <div className="container px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          {...headerAnimation}
          transition={smoothTransition}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">La Solución Inteligente</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Te enseñaron que un menú es solo una lista, pero en realidad es la{' '}
            <span className="text-gradient">herramienta de ventas más importante</span> de tu negocio.
          </h2>
          
          <p className="text-lg sm:text-xl text-muted-foreground mb-8">
            Cada cliente pasa por ahí. Y en ese momento decide cuánto va a gastar.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            {...leftAnimation}
            transition={springTransition}
            className="relative"
          >
            <SolutionImage inView={inView} />
          </motion.div>

          <motion.div
            {...rightAnimation}
            transition={{ duration: 0.7, delay: 0.3 }}
          >
            <SolutionContent inView={inView} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
